import type { paths } from './ApiTypes';
//import * as Sentry from "@sentry/browser";

export class ApiClient {
    private static instance: ApiClient | null = null;
    //private baseUrl = 'https://hra.betvector.com/api/v1/lottery-game/';
    //private baseUrl = 'https://onebet-prod.blackbet.eu/api/v1/lottery-game/';
    //private baseUrl = 'http://172.28.4.245:55101/api/v1/lottery-game/';
    private baseUrl = '/api/v1/lottery-game/';
    private token?: string;
    private playerId?: string;

    private constructor() {
        //if (process.env.NODE_ENV == 'development')
        // this.baseUrl = '/api/v1/lottery-game/';
    }

    public static getInstance(): ApiClient {
        if (!ApiClient.instance)
            ApiClient.instance = new ApiClient();
        return ApiClient.instance;
    }

    public setToken(token: string): void {
        this.token = token;
    }

    public getToken(): string | undefined {
        return this.token;
    }

    public setPlayerId(playerId: string): void {
        this.playerId = playerId;
    }

    public getPlayerId(): string | undefined {
        return this.playerId;
    }


    private logToSentry(url: string, method: string, status: any, statusText: string, startedAt: number, body: any, logLevel: "error" | "warning") {
        /*
        Sentry.withScope((scope) => {
            scope.setLevel(logLevel);
            scope.setTag("http.method", method);
            scope.setTag("http.status_code", String(status));
            scope.setContext("http", {
                url,
                method,
                status: status,
                statusText: statusText,
                durationMs: Math.round(performance.now() - startedAt),
            });

            scope.setContext("request", {
                hasBody: body != null,
            });

            Sentry.captureMessage(`HTTP ${status} ${method} ${url}`);
        });
        */
    }

    private async post<TReq, TRes>(endpoint: string, body: TReq, onFinish?: (resp?: TRes, error?: Error) => void): Promise<TRes> {
        const startedAt = performance.now();
        try {
            const res = await fetch(`${this.baseUrl}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
            if (res.status != 200) {
                const serverError = new Error('Server error, response status: ' + res.status);
                this.logToSentry(endpoint, 'post', res.status, serverError.message, startedAt, body, 'error');
                if (onFinish)
                    onFinish(undefined, serverError)
                throw serverError;
            }
            const json = await res.json();
            if('status' in json && json.status.toLowerCase() != 'ok'){
                this.logToSentry(endpoint, 'post', 'HTTP NOT OK STATUS', json.status, startedAt, {request: body, response: json}, 'error');
            }
            if (onFinish)
                onFinish(json)
            /* TODO Tohle uz je jinak, errory obecne poresit
            if (json.status && json.status !== 'OK' && json.status !== 'ok'){
                const unknownError = new Error(json.message || 'Unknown API error');
                if(onFinish)
                    onFinish(undefined, unknownError)
                throw unknownError;
            }
            */
            return json as TRes;
        } catch (err: any) {
            this.logToSentry(endpoint, 'post', 'HTTP THROW', err?.message ?? String(err), startedAt, body, 'error');
            throw err;
        }
    }

    /** Document Document request */
    public async document(reg: DocumentRequest): Promise<DocumentResponse> {
        return this.post<DocumentRequest, DocumentResponse>('document', reg);
    }

    /** Results request */
    public async results(reg: ResultsRequest): Promise<ResultsResponse> {
        return this.post<ResultsRequest, ResultsResponse>('results', reg);
    }

    /** Client Result request */
    public async clientResult(reg: ClientResultRequest): Promise<ClientResultResponse> {
        return this.post<ClientResultRequest, ClientResultResponse>('client-result', reg);
    }

    /** Statistics Statistics request */
    public async statistics(): Promise<StatisticsResponse> {
        return this.post<any, StatisticsResponse>('statistics', {});
    }

    /** Launch Used for web object integration. */
    public async launch(req: AuthRequest): Promise<LaunchResponse> {
        return this.post<AuthRequest, LaunchResponse>('launch', req);
    }

    /** GameRoundList Game Round List request */
    public async gameRoundList(req: GameRoundListRequest): Promise<GameRoundListResponse> {
        return this.post<GameRoundListRequest, GameRoundListResponse>('game-round-list', req);
    }

    /** BetslipDetail BetslipDetail request */
    public async betslipDetail(req: BetslipDetailRequest): Promise<BetslipDetailResponse> {
        return this.post<BetslipDetailRequest, BetslipDetailResponse>('betslip-detail', req);
    }

    /** HandshakeToken Used for web object integration. */
    public async handshakeToken(req: AuthRequest): Promise<HandshakeTokenResponse> {
        return this.post<AuthRequest, HandshakeTokenResponse>('handshake-token', req);
    }

    /** WinnerList Winner List request */
    public async winnerList(req: WinnerListRequest): Promise<WinnerListResponse> {
        return this.post<WinnerListRequest, WinnerListResponse>('winner-list', req);
    }

    /** SaveBetslip Save Betslip request */
    public async saveBetslip(req: SaveBetslipRequest, onFinish?: (resp?: SaveBetslipResponse, error?: Error) => void): Promise<SaveBetslipResponse> {
        return this.post<SaveBetslipRequest, SaveBetslipResponse>('save-betslip', req, onFinish);
    }

    /** ValidateBetslip Validate Betslip request */
    public async validateBetslip(req: ValidateBetslipRequest): Promise<ValidateBetslipResponse> {
        return this.post<ValidateBetslipRequest, ValidateBetslipResponse>('validate-betslip', req);
    }

    /** BetslipList BetslipList request */
    public async betslipList(): Promise<BetslipListResponse> {
        return this.post<any, BetslipListResponse>('betslip-list', {});
    }

    /** Offer Offer request */
    public async offer(req: OfferRequest): Promise<OfferResponse> {
        return this.post<OfferRequest, OfferResponse>('offer', req);
    }

    /** Offer Offer request */
    public async jackpot(req: JackpotRequest): Promise<JackpotResponse> {
        return this.post<JackpotRequest, JackpotResponse>('jackpot-diff', req);
    }

    /** GameRoundList Game Round List request */
    public async tableWin(req: TableWinRequest): Promise<TableWinResponse> {
        return this.post<TableWinRequest, TableWinResponse>('table-win', req);
    }

    public async tableDrawnNumbersCounter(req: TableDrawnNumbersRequest): Promise<TableDrawnNumbersResponse> {
        return this.post<TableDrawnNumbersRequest, TableDrawnNumbersResponse>('table-drawn-numbers-counter', req);
    }

    public async ticketDetail(req: TicketDetailRequest): Promise<TicketDetailResponse> {
        return this.post<TicketDetailRequest, TicketDetailResponse>('ticket-detail', req);
    }

    public async superTicketDetail(req: TicketDetailRequest): Promise<SuperTicketDetailResponse> {
        return this.post<TicketDetailRequest, SuperTicketDetailResponse>('super-ticket-detail', req);
    }

    public async offerDetail(req: OfferDetailRequest): Promise<OfferDetailResponse> {
        return this.post<OfferDetailRequest, OfferDetailResponse>('offer-detail', req);
    }

    public async video(req: VideoRequest): Promise<VideoResponse> {
        return this.post<VideoRequest, VideoResponse>('video', req);
    }
}


// === Shared Base Response ===

export interface ApiResponse {
    status: string;
    code?: string;
    message?: string;
    data?: any;
}

// === Shared Base Request ===

export interface AuthRequest {
    token: string;
}

// === Interfaces ===

export interface DocumentResponse extends ApiResponse { data: { content: string; }; }
export interface DocumentRequest { documentIdent: string; }
export interface JackpotWin {
    type: "Jackpot";
    amount_win: number;
    amount_individual: number;
    amount_fixed_max: number | null;
    amount_split: number | null;
}
export interface FixedWin {
    type: "Fixed";
    amount: number;
}
export interface OddsWin {
    type: "Odds";
    odds: number;
}
export interface SplitFixedWin {
    type: "SplitFixed";
    amount_win: number;
    amount_split: number | null;
    amount_fixed_max: number | null;
    group: number;
}
export interface SplitOddsWin {
    type: "SplitOdds";
    odds: number;
    amount_fixed_max: number | null;
    amount_split: number | null;
    group: number;
}
export interface CombiOdds {
    numbers: number[];
    odds: number;
}
export interface CombiWin {
    type: "Combi";
    wins: CombiOdds[];
    win_combinations_cnt: number;
    lost_combinations_cnt: number;
    odds: number;
}

export type SingleWinType =
    | JackpotWin
    | FixedWin
    | OddsWin
    | SplitFixedWin
    | SplitOddsWin
    | CombiWin;

export interface MultiWin {
    type: "Multi";
    wins: SingleWinType[];
}

export type WinType = SingleWinType | MultiWin;

export interface TicketDetailRequest { externalId: string; token?: string }
export type TicketDetailResponse = paths['/api/v1/lottery-game/ticket-detail']['post']['responses']['200']['content']['application/json'];
export type TicketDetailData = paths['/api/v1/lottery-game/ticket-detail']['post']['responses']['200']['content']['application/json']['data'];

export type SuperTicketDetailResponse = paths['/api/v1/lottery-game/super-ticket-detail']['post']['responses']['200']['content']['application/json'];

export interface OfferDetailRequest { lotteryDrawId: string; }
export type OfferDetailResponse = paths['/api/v1/lottery-game/offer-detail']['post']['responses']['200']['content']['application/json'];

export interface VideoRequest { ident: string; id_offer: number }

export interface VideoResponseVideo {
    video: string;
    filename: string;
}
export interface VideoResponse extends ApiResponse {
    video: {
        id_offer: number;
        videos: Array<VideoResponseVideo>;
    }
}

export interface ClientResultRequest {
    ident: string;
    idOffer: number;
    token?: string;
}

export interface ClientResultResponse extends ApiResponse {
    data: {
        result: OfferEntry,
        tickets: Array<TicketDetailData>
    }
}

export interface ResultsRequest {
    filter: {
        ident: string;
        args: ResultsRequestArgs
    };
}

export type ResultsRequestArgs = { type: "offers", offersCount: number } | { type: "hours", hours: number };

export interface ResultsResponse extends ApiResponse {
    results: Array<ResultsResult>;
}

export interface ResultsResult {
    id_offer: number;
    ident: string;
    offer: NumberOffer;
    result: ApiBets;
    created_at: string;
    event_start_at: string;
    event_end_at: string;
}

export interface StatisticsResponse extends ApiResponse { data: Record<string, any>; }

export interface LaunchResponse extends ApiResponse {
    token: string;
}

export interface GameRoundListRequest { filter: { limit?: number; offset?: number; listType: 'available' | 'next'; }; }

export interface GameRoundListResponse extends ApiResponse {
    data: {
        roundId: string;
        startTs: string;
        game: {
            name: string;
            ident: string;
            image: Record<string, any>;
        };
    }[];
}

export interface BetslipDetailRequest { betslipId: string; }

export interface BetslipDetailResponse extends ApiResponse { data: { betslip: Record<string, any>; }; }

export interface HandshakeTokenResponse extends ApiResponse { data: { player: { id: string; credit: number; }; }; }

export interface WinnerListRequest { filter: { limit: number; offset: number; listType: 'last' | 'top'; gameIdent: string; }; }

export interface WinnerListResponse extends ApiResponse { data: Array<WinnerListWinner>; }

export interface JackpotRequest { ident: string; }
export interface JackpotResponse {
    jackpot: {
        speed: number,
        amount: number
    }
}

export interface TableDrawnNumbersRequest { ident: string; }
export interface TableDrawnNumbersResponse { table: { most_drawn: Array<Array<number>>, least_drawn: Array<Array<number>> } }


export interface WinnerListWinner {
    player: {
        playerId: string;
        nickname: string;
    },
    game: {
        name: string;
        ident: string;
        image: string;
    },
    win: number;
    win_time: Date;
}
export interface SaveBetslipRequest extends AuthRequest {
    betslip: {
        stake: number;
        items: Array<SaveBetslipItem>
    }
}

export interface SaveBetslipItem {
    ident: string;
    id_offer: number;
    repeat: number;
    bets: Array<ApiBets | ApiBetsCombi>;
}

export interface ApiBets {
    type: "NumberBet",
    numbers: Array<number>
}

export interface ApiBetsCombi {
    type: "NumberCombiBet",
    columns: Array<Array<number>>
}


export type SaveBetslipResponse = paths['/api/v1/lottery-game/save-betslip']['post']['responses']['200']['content']['application/json'];

export interface ValidateBetslipRequest {
    betslip: {
        ident: string;
        id_offer: number;
        stake: number;
        bets: Record<string, any>[];
    };
}

export interface ValidateBetslipResponse extends ApiResponse { data: { isValid: boolean; errors?: string[]; }; }

export interface BetslipListResponse extends ApiResponse { data: { betslips: Record<string, any>[]; }; }

export interface OfferRequest { ident: string; }

export interface OfferResponse extends ApiResponse {
    offer: OfferEntry[];
    server_time: string;
}

export interface OfferEntry {
    id_offer: number;
    id_external: string;
    ident: string;
    offer: NumberOffer | NumberCombiOffer;
    result: null | any;
    event_start_at: string;
    event_end_at: string;
}

export interface NumberOffer {
    type: 'NumberOffer';
    numbers_total: number;
    first_number: number;
    odds: OddsEntry[];
    bet_numbers_min: number;
    bet_numbers_max: number;
}

export interface NumberCombiOffer {
    type: "NumberCombiOffer",
    range_from_inc: number,
    range_to_inc: number,
    columns_cnt: number,
    bet_numbers_per_column_min: number,
    bet_numbers_per_column_max: number
}

export interface OddsEntry {
    matches: number;
    odds: number;
}

export interface TableWinRequest {
    ident: string;
    bet: ApiBets
}
export interface TableWinResponse {
    table: {
        type: string;
        draws: Array<TableWinDraw>;
    };
}

export interface TableWinDraw {
    name: string;
    order_win: Array<TableWinNumberOdds>;
}

export interface TableWinNumberOdds {
    type: "NumberOdds";
    numbers: Array<TableWinNumberToken> | Array<Array<TableWinNumberToken>>;
    amount: number;
}
export interface TableWinNumberToken {
    type: "Hit" | "Miss" | "Special";
    value: number | string;
}
